<script setup lang="ts">
import { RouterView } from 'vue-router';
</script>

<template>
  <div class="app-shell">
    <RouterView />
  </div>
</template>

<style>
:root {
  font-family: var(--kp-font-family-base, system-ui);
  color: var(--kp-color-text-primary, #1a1a1a);
  background: var(--kp-color-bg-base, #f7f7f8);
  font-size: 16px;
}
/* 全局字号三档 */
html.kp-fs-standard { font-size: 16px; }
html.kp-fs-large { font-size: 17.5px; }
html.kp-fs-xlarge { font-size: 19px; }

html, body, #app, .app-shell {
  margin: 0;
  padding: 0;
  min-height: 100vh;
}
*, *::before, *::after { box-sizing: border-box; }
</style>
